module.exports = __webpack_public_path__ + "img/download_explain_4.3e2474b2.png";